import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'yankees-react-utils';
import { useBlobDownloadQuery } from '../data';

const ImageProtectedDisplay = ({ imgurl, alt, style, ...rest }) => {
    const [loaded, setLoaded] = useState(false);
    const { src } = useBlobDownloadQuery(imgurl);
    return (
        <>
            {!loaded && <LoadingSpinner />}
            <img src={src} alt={alt} style={loaded ? style : { display: 'none' }} onLoad={() => setLoaded(true)} {...rest} />
        </>
    );
};

ImageProtectedDisplay.defaultProps = {
    alt: '',
    style: null,
};

ImageProtectedDisplay.propTypes = {
    imgurl: PropTypes.string.isRequired,
    alt: PropTypes.string,
    style: PropTypes.shape({}),
};

export default ImageProtectedDisplay;
